/**
 * Eye laterality — `BACKLOG.md` M10, the international ophthalmic convention (oculus dexter/sinister/
 * uterque), deliberately distinct from `bodyMapping.ts`'s generic `BODY_MAP_SIDES` (`left`/`right`).
 * See `db/schema/ophthalmology.ts`'s own header for why this is a separate vocabulary rather than a
 * relabeling of the generic one.
 */

export const EYE_LATERALITIES = ['OD', 'OS', 'OU'] as const;
export type EyeLaterality = (typeof EYE_LATERALITIES)[number];

export function isEyeLaterality(value: string): value is EyeLaterality {
  return (EYE_LATERALITIES as readonly string[]).includes(value);
}

/** Cataract surgery is always single-eye — `OU` never applies to a surgical plan. */
export const SURGICAL_EYE_LATERALITIES = ['OD', 'OS'] as const;
export type SurgicalEyeLaterality = (typeof SURGICAL_EYE_LATERALITIES)[number];

export function isSurgicalEyeLaterality(value: string): value is SurgicalEyeLaterality {
  return (SURGICAL_EYE_LATERALITIES as readonly string[]).includes(value);
}

const EYE_LATERALITY_LABELS: Readonly<Record<EyeLaterality, string>> = {
  OD: 'Right eye (OD)',
  OS: 'Left eye (OS)',
  OU: 'Both eyes (OU)',
};

/** English-only domain vocabulary — see `orthopedics/conditionTemplates.ts`'s `conditionTypeLabel` for
 * the shared-function-not-locale-key precedent this follows. */
export function eyeLateralityLabel(eye: EyeLaterality): string {
  return EYE_LATERALITY_LABELS[eye];
}
